<template>
    <nav id="topnav" class="defaultscroll is-sticky">
        <div id="dropdown" />
        <div class="container">
            <!-- Logo container-->
            <Link :href="route('home')" class="logo pl-0 mt-2 mb-2">
                <logo class="help-desk-logo" />
            </Link>

            <!-- End Logo container-->
            <div class="menu-extras">
                <div class="menu-item">
                    <!-- Mobile menu toggle-->
                    <div class="navbar-toggle cursor-pointer" id="isToggle" @click="toggleMenu">
                        <div class="lines">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <!-- End mobile menu toggle-->
                </div>
            </div>


            <div id="navigation">
                <!-- Navigation Menu-->
                <ul class="navigation-menu">
                    <li :class="{'active' : active_menu === 'home'}"><Link :href="route('home')" @click="active_menu = 'home'" class="sub-menu-item">{{ __('Home') }}</Link></li>
                    <li v-if="!!this.enable_option && this.enable_option.service" :class="{'active' : active_menu === 'our-services'}"><Link :href="route('our_services')" @click="active_menu = 'our-services'" class="sub-menu-item">{{ __('Services') }}</Link></li>
                    <li v-if="!!this.enable_option && this.enable_option.kb" :class="{'active' : active_menu === 'kb'}"><Link :href="route('kb')" @click="active_menu = 'kb'" class="sub-menu-item">{{ __('Knowledge') }}</Link></li>
                    <li v-if="!!this.enable_option && this.enable_option.faq" :class="{'active' : active_menu === 'faq'}"><Link :href="route('faq')" @click="active_menu = 'faq'" class="sub-menu-item">{{ __('FAQs')}}</Link></li>
                    <li v-if="!!this.enable_option && this.enable_option.blog" :class="{'active' : active_menu === 'blog'}"><Link :href="route('blog')" @click="active_menu = 'blog'" class="sub-menu-item">{{ __('Blog')}}</Link></li>
                    <li v-if="!!this.enable_option && this.enable_option.contact" :class="{'active' : active_menu === 'contact'}"><Link :href="route('contact')" @click="active_menu = 'contact'" class="sub-menu-item">{{ __('Contact')}}</Link></li>
                    <li class="" v-if="!!this.enable_option && this.enable_option.show_login && !$page.props.auth.user"><a :href="route('login')">Login</a></li>
                    <li class="dd__wrapper" v-if="$page.props.auth.user">
                        <dropdown class="mt-1 select_user" placement="bottom-end">
                            <template #default>
                                <div class="flex items-center cursor-pointer group">
                                    <div class=" mr-1 whitespace-nowrap">
                                        <img v-if="$page.props.auth.user.photo" class="user_photo w-8 h-8" :alt="$page.props.auth.user.first_name" :src="$page.props.auth.user.photo" />
                                        <img v-else src="/images/svg/profile.svg" class="w-8 h-8" alt="user profile" />
                                    </div>
                                    <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                                </div>
                            </template>
                            <template #dropdown>
                                <div class="shadow-xl bg-white rounded text-sm">
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('dashboard')">{{ __('Dashboard') }}</Link>
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('tickets')">{{ __('Tickets') }}</Link>
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('users.edit.profile')">{{ __('Edit Profile') }}</Link>
                                    <Link class="block px-6 py-2 hover:bg-indigo-500 hover:text-white w-full text-left" :href="route('logout')" method="delete" as="button">{{ __('Logout') }}</Link>
                                </div>
                            </template>
                        </dropdown>
                    </li>
                    <li class="a_t_button" v-if="!$page.props.auth.user"><Link :href="route('ticket_open')" class="btn flex"><icon class="w-4 w-4 inline-block fill-gray-100" name="send_plan" /> Submit Ticket</Link></li>
                    <li class="relative pt-3 pb-3 md:pt-0 md:pb-0 rtl:pr-[55px]">
                        <dropdown class="ml-2 rtl:mr-2 relative md:absolute md:top-[26px] md:left-0 language_menu_wrapper" placement="bottom-end">
                            <template #default>
                                <div class="flex items-center cursor-pointer group language_menu">
                                    <div class=" font-bold mr-1 rtl:mr-0 whitespace-nowrap">
                                        <icon class="w-5 h-5" :name="selected_language.code" /> <span class="rtl:mr-[6px]">{{ selected_language.code }}</span>
                                    </div>
                                    <icon class="w-5 h-5 drop-down-caret-icon" name="cheveron-down" />
                                </div>
                            </template>
                            <template #dropdown>
                                <div class=" py-2 shadow-xl rounded text-sm language_menu_list">
                                    <Link v-for="language in languages_except_selected" :key="language.code" class="block px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('language', [language.code])">
                                        <icon class="w-5 h-5" :name="language.code" /> <span class="lang_name rtl:mr-[6px]">{{ language.name }}</span>
                                    </Link>
                                </div>
                            </template>
                        </dropdown>
                    </li>
                </ul><!--end navigation menu-->
            </div><!--end navigation-->
        </div><!--end container-->
    </nav>
</template>
<script>
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/inertia-vue3'
export default {
    components: {
        Logo,
        Icon,
        Dropdown,
        Link
    },
    data(){
        return {
            active_menu: 'home',
            enable_option: {}
        }
    },
    computed: {
        selected_language() {
            return this.$page.props.languages.find(language => language.code === this.$page.props.locale)
        },
        languages_except_selected(){
            return this.$page.props.languages.filter(language => language.code !== this.$page.props.locale)
        }
    },
    methods: {
        toggleMenu(){
            document.getElementById('isToggle').classList.toggle('open');
            var isOpen = document.getElementById('navigation')
            if (isOpen.style.display === "block") {
                isOpen.style.display = "none";
            } else {
                isOpen.style.display = "block";
            }
        },
        windowScroll(){
            const navbar = document.getElementById("topnav");
            if (navbar != null) {
                if (
                    document.body.scrollTop >= 50 ||
                    document.documentElement.scrollTop >= 50
                ) {
                    navbar.classList.add("nav-sticky");
                } else {
                    navbar.classList.remove("nav-sticky");
                }
            }
        }
    },
    mounted() {
      this.active_menu = this.$page.url.substr(1) || 'home'
    },
    created() {
        if(this.$page.props.enable_options){
            let options = JSON.parse(this.$page.props.enable_options.value)
            options.forEach(option=>{
                this.enable_option[option.slug] = !!option.value
            })
        }
        window.addEventListener('scroll', (ev) => {
            ev.preventDefault();
            this.windowScroll();
        })
    }
}
</script>
